export default {
  namespaced: true,
  axis_body_cam: {
    title: 'Axis Body Cam',
    overview: {
      title: 'Geral',
      devices: 'Câmeras',
      users: 'Usuários',
      recordings: 'Gravações',
      total: 'Total',
      active: 'Ativos',
      today: 'Hoje',
      transferring: 'Transferindo',
      complete: 'Completas',
      storage_used: 'Armazenamento usado',
      recent_recordings: 'Gravações recentes',
      configure_dock: 'Configuração Body Worn Collector',
      configure_dock_hint: 'Baixe o arquivo de conexão para cadastrar um dock no Body Worn Manager',
    },
    devices: {
      title: 'Câmeras',
      serial_number: 'Série',
      model: 'Modelo',
      name: 'Nome',
      active: 'Ativo',
      assigned_user: 'Usuário atribuído',
      system_controller: 'Dock',
      recordings_count: 'Gravações',
      last_synced_at: 'Última sincronização',
      device_tag: 'Tag',
      reseller: 'Reseller',
      proxy_rtsp_server: 'Stream (herdado do dock)',
      no_locations_for_day: 'Sem localizações registradas nesse dia',
    },
    system_controllers: {
      title: 'Docks',
      serial_number: 'Série',
      model: 'Modelo',
      name: 'Nome',
      units: 'Instalações',
      devices_count: 'Câmeras',
      last_synced_at: 'Última sincronização',
      proxy_rtsp_server: 'Stream',
      users: 'Usuários com acesso',
      groups: 'Grupos com acesso',
    },
    users: {
      title: 'Usuários',
      name: 'Nome',
      active: 'Ativo',
      devices_count: 'Câmeras',
      recordings_count: 'Gravações',
      last_synced_at: 'Última sincronização',
    },
    recordings: {
      title: 'Gravações',
      container_name: 'Sessão',
      user: 'Usuário',
      device: 'Câmera',
      start_time: 'Início',
      stop_time: 'Fim',
      status: 'Status',
      files: 'Arquivos',
      download: 'Baixar',
      no_files: 'Sem arquivos',
      play: 'Reproduzir',
      download_all: 'Baixar tudo',
      download_started: 'Download iniciado',
      links_error: 'Não foi possível obter os links da gravação',
      part: 'Parte',
      playing: 'Reproduzindo',
      unsupported_format: 'Este navegador não reproduz MKV, use Chrome/Edge ou baixe o arquivo',
      part_error: 'Não foi possível reproduzir esta parte',
      no_videos: 'Esta gravação não tem vídeo',
    },
  },
}
